<template>
  <div class="clinic-dashboard" v-loading="isPageLoading">
    <div class="dashboard-page-head">
      <div class="page-head-content">
        <div class="page-head-left">
          <div style="display: flex; align-items: center; gap: 8px;">
            <h1 class="page-title">Clinic Charting</h1>
            <span class="update-time" v-if="cacheUpdateTime && getTimeDifferenceFromNow(cacheUpdateTime)">(Updated {{ getTimeDifferenceFromNow(cacheUpdateTime) }})</span>
          </div>
          
          <p class="page-description">Overview of engagement, financial performance, and provider activity.</p>
        </div>
        <div class="page-head-actions">
          <div class="resources-tools-wrapper" ref="resourcesToolsRef">
            <ResponsiveButton 
              display_name="Resources & Tools" 
              size="medium" 
              built_in_theme="light" 
              @click-button="toggleResourcesDropdown"
            >
              <template #prefix>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.49 11.38C13.92 10.16 13.66 8.74 12.68 7.76C11.57 6.65 9.89 6.46 8.58 7.17L10.93 9.52L9.52 10.93L7.17 8.58C6.46 9.9 6.65 11.57 7.76 12.68C8.74 13.66 10.16 13.92 11.38 13.49L14.79 16.9C14.99 17.1 15.3 17.1 15.5 16.9L16.9 15.5C17.1 15.3 17.1 14.99 16.9 14.79L13.49 11.38Z" fill="white"/>
                </svg>
              </template>
            </ResponsiveButton>
            
            <!-- <Button color-type="sky-blue" @click="toggleResourcesDropdown">
              <div style="display: flex; align-items: center; gap: 8px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M13.49 11.38C13.92 10.16 13.66 8.74 12.68 7.76C11.57 6.65 9.89 6.46 8.58 7.17L10.93 9.52L9.52 10.93L7.17 8.58C6.46 9.9 6.65 11.57 7.76 12.68C8.74 13.66 10.16 13.92 11.38 13.49L14.79 16.9C14.99 17.1 15.3 17.1 15.5 16.9L16.9 15.5C17.1 15.3 17.1 14.99 16.9 14.79L13.49 11.38Z" fill="white"/>
                </svg>
                <span>Resources & Tools</span>
              </div>
            </Button> -->
            
            <!-- Resources & Tools Dropdown -->
            <div v-if="showResourcesDropdown" class="resources-dropdown">
              <div class="tools-grid">
                <div class="tool-card" @click="handleToolClick('fedex')">
                  <div class="tool-content-wrapper">
                    <div class="tool-icon" style="background-color: #E1D3F1;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="16" viewBox="0 0 23 16" fill="none">
                        <path d="M6.5 16C5.66667 16 4.95833 15.7083 4.375 15.125C3.79167 14.5417 3.5 13.8333 3.5 13H1L1.45 11H4.275C4.55833 10.6833 4.89167 10.4375 5.275 10.2625C5.65833 10.0875 6.06667 10 6.5 10C6.93333 10 7.34167 10.0875 7.725 10.2625C8.10833 10.4375 8.44167 10.6833 8.725 11H12.9L15 2H4.05L4.15 1.575C4.25 1.10833 4.47917 0.729167 4.8375 0.4375C5.19583 0.145833 5.61667 0 6.1 0H17.5L16.575 4H19.5L22.5 8L21.5 13H19.5C19.5 13.8333 19.2083 14.5417 18.625 15.125C18.0417 15.7083 17.3333 16 16.5 16C15.6667 16 14.9583 15.7083 14.375 15.125C13.7917 14.5417 13.5 13.8333 13.5 13H9.5C9.5 13.8333 9.20833 14.5417 8.625 15.125C8.04167 15.7083 7.33333 16 6.5 16ZM15.425 9H20.25L20.35 8.475L18.5 6H16.125L15.425 9ZM14.95 2.175L15 2L12.9 11L12.95 10.825L13.8 7.175L14.95 2.175ZM0 9.325L0.5 7.325H6L5.5 9.325H0ZM2 5.675L2.5 3.675H9L8.5 5.675H2ZM6.5 14C6.78333 14 7.02083 13.9042 7.2125 13.7125C7.40417 13.5208 7.5 13.2833 7.5 13C7.5 12.7167 7.40417 12.4792 7.2125 12.2875C7.02083 12.0958 6.78333 12 6.5 12C6.21667 12 5.97917 12.0958 5.7875 12.2875C5.59583 12.4792 5.5 12.7167 5.5 13C5.5 13.2833 5.59583 13.5208 5.7875 13.7125C5.97917 13.9042 6.21667 14 6.5 14ZM16.5 14C16.7833 14 17.0208 13.9042 17.2125 13.7125C17.4042 13.5208 17.5 13.2833 17.5 13C17.5 12.7167 17.4042 12.4792 17.2125 12.2875C17.0208 12.0958 16.7833 12 16.5 12C16.2167 12 15.9792 12.0958 15.7875 12.2875C15.5958 12.4792 15.5 12.7167 15.5 13C15.5 13.2833 15.5958 13.5208 15.7875 13.7125C15.9792 13.9042 16.2167 14 16.5 14Z" fill="#6F4999"/>
                      </svg>
                    </div>
                    <div class="tool-content">
                      <p class="tool-title">Fedex Pickup</p>
                      <p class="tool-description">Schedule a pickup</p>
                    </div>
                  </div>
                  <svg class="tool-arrow" xmlns="http://www.w3.org/2000/svg" width="22" height="36" viewBox="0 0 22 36" fill="none">
                    <path d="M0 31.77L13.5978 18L0 4.23L4.18623 0L22 18L4.18623 36L0 31.77Z" fill="#E0E0E0"/>
                  </svg>
                </div>
                
                <div class="tool-card" @click="handleToolClick('calculator')">
                  <div class="tool-content-wrapper">
                    <div class="tool-icon" style="background-color: #F8FCF2;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V5H19V19Z" fill="#20A7C1"/>
                        <path d="M11.25 7.72H6.25V9.22H11.25V7.72Z" fill="#20A7C1"/>
                        <path d="M18 15.75H13V17.25H18V15.75Z" fill="#20A7C1"/>
                        <path d="M18 13.25H13V14.75H18V13.25Z" fill="#20A7C1"/>
                        <path d="M8 18H9.5V16H11.5V14.5H9.5V12.5H8V14.5H6V16H8V18Z" fill="#20A7C1"/>
                        <path d="M14.09 10.95L15.5 9.54L16.91 10.95L17.97 9.89L16.56 8.47L17.97 7.06L16.91 6L15.5 7.41L14.09 6L13.03 7.06L14.44 8.47L13.03 9.89L14.09 10.95Z" fill="#20A7C1"/>
                      </svg>
                    </div>
                    <div class="tool-content">
                      <p class="tool-title">Price Calculator</p>
                      <p class="tool-description">Calculate pricing</p>
                    </div>
                  </div>
                  <svg class="tool-arrow" xmlns="http://www.w3.org/2000/svg" width="22" height="36" viewBox="0 0 22 36" fill="none">
                    <path d="M0 31.77L13.5978 18L0 4.23L4.18623 0L22 18L4.18623 36L0 31.77Z" fill="#E0E0E0"/>
                  </svg>
                </div>

                <div class="tool-card" @click="handleToolClick('blood-draw')">
                  <div class="tool-content-wrapper">
                    <div class="tool-icon" style="background-color: #E4F3F5;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M11.5 5.25H8.5V3.75H9C9.55 3.75 10 3.3 10 2.75C10 2.2 9.55 1.75 9 1.75H6C5.45 1.75 5 2.2 5 2.75C5 3.3 5.45 3.75 6 3.75H6.5V5.25H3.5C2.95 5.25 2.5 5.7 2.5 6.25C2.5 6.8 2.95 7.25 3.5 7.25V14.75C3.5 15.85 4.4 16.75 5.5 16.75H6.5V20.75L8.5 22.25V16.75H9.5C10.6 16.75 11.5 15.85 11.5 14.75V7.25C12.05 7.25 12.5 6.8 12.5 6.25C12.5 5.7 12.05 5.25 11.5 5.25ZM9.5 8.75H7.75C7.34 8.75 7 9.09 7 9.5C7 9.91 7.34 10.25 7.75 10.25H9.5V11.75H7.75C7.34 11.75 7 12.09 7 12.5C7 12.91 7.34 13.25 7.75 13.25H9.5V14.75H5.5V7.25H9.5V8.75ZM20 10.25V9.75C20.55 9.75 21 9.3 21 8.75C21 8.2 20.55 7.75 20 7.75H15C14.45 7.75 14 8.2 14 8.75C14 9.3 14.45 9.75 15 9.75V10.25C15 10.75 13.5 11.41 13.5 13.25V19.75C13.5 20.85 14.4 21.75 15.5 21.75H19.5C20.6 21.75 21.5 20.85 21.5 19.75V13.25C21.5 11.41 20 10.75 20 10.25ZM17 10.25V9.75H18V10.25C18 11.85 19.5 12.25 19.5 13.25V13.75H15.5C15.5 13.54 15.5 13.36 15.5 13.25C15.5 12.25 17 11.85 17 10.25ZM19.5 15.25V16.75H15.5C15.5 16.24 15.5 15.73 15.5 15.25H19.5ZM15.5 19.75C15.5 19.75 15.5 19.12 15.5 18.25H19.5V19.75H15.5Z" fill="#5587BC"/>
                      </svg>
                    </div>
                    <div class="tool-content">
                      <p class="tool-title">Blood Draw</p>
                      <p class="tool-description">Find a phlebotomist</p>
                    </div>
                  </div>
                  <svg class="tool-arrow" xmlns="http://www.w3.org/2000/svg" width="22" height="36" viewBox="0 0 22 36" fill="none">
                    <path d="M0 31.77L13.5978 18L0 4.23L4.18623 0L22 18L4.18623 36L0 31.77Z" fill="#E0E0E0"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>

          <ResponsiveButton 
          display_name="Practice Setting" 
          size="medium" 
          @click-button = "goToPracticeSettingPage"
          >
            <template #prefix>
               <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M19.4323 12.98C19.4723 12.66 19.5023 12.34 19.5023 12C19.5023 11.66 19.4723 11.34 19.4323 11.02L21.5423 9.37C21.7323 9.22 21.7823 8.95 21.6623 8.73L19.6623 5.27C19.5723 5.11 19.4023 5.02 19.2223 5.02C19.1623 5.02 19.1023 5.03 19.0523 5.05L16.5623 6.05C16.0423 5.65 15.4823 5.32 14.8723 5.07L14.4923 2.42C14.4623 2.18 14.2523 2 14.0023 2H10.0023C9.75228 2 9.54228 2.18 9.51228 2.42L9.13228 5.07C8.52228 5.32 7.96228 5.66 7.44228 6.05L4.95228 5.05C4.89228 5.03 4.83228 5.02 4.77228 5.02C4.60228 5.02 4.43228 5.11 4.34228 5.27L2.34228 8.73C2.21228 8.95 2.27228 9.22 2.46228 9.37L4.57228 11.02C4.53228 11.34 4.50228 11.67 4.50228 12C4.50228 12.33 4.53228 12.66 4.57228 12.98L2.46228 14.63C2.27228 14.78 2.22228 15.05 2.34228 15.27L4.34228 18.73C4.43228 18.89 4.60228 18.98 4.78228 18.98C4.84228 18.98 4.90228 18.97 4.95228 18.95L7.44228 17.95C7.96228 18.35 8.52228 18.68 9.13228 18.93L9.51228 21.58C9.54228 21.82 9.75228 22 10.0023 22H14.0023C14.2523 22 14.4623 21.82 14.4923 21.58L14.8723 18.93C15.4823 18.68 16.0423 18.34 16.5623 17.95L19.0523 18.95C19.1123 18.97 19.1723 18.98 19.2323 18.98C19.4023 18.98 19.5723 18.89 19.6623 18.73L21.6623 15.27C21.7823 15.05 21.7323 14.78 21.5423 14.63L19.4323 12.98ZM17.4523 11.27C17.4923 11.58 17.5023 11.79 17.5023 12C17.5023 12.21 17.4823 12.43 17.4523 12.73L17.3123 13.86L18.2023 14.56L19.2823 15.4L18.5823 16.61L17.3123 16.1L16.2723 15.68L15.3723 16.36C14.9423 16.68 14.5323 16.92 14.1223 17.09L13.0623 17.52L12.9023 18.65L12.7023 20H11.3023L10.9523 17.52L9.89228 17.09C9.46228 16.91 9.06228 16.68 8.66228 16.38L7.75228 15.68L6.69228 16.11L5.42228 16.62L4.72228 15.41L5.80228 14.57L6.69228 13.87L6.55228 12.74C6.52228 12.43 6.50228 12.2 6.50228 12C6.50228 11.8 6.52228 11.57 6.55228 11.27L6.69228 10.14L5.80228 9.44L4.72228 8.6L5.42228 7.39L6.69228 7.9L7.73228 8.32L8.63228 7.64C9.06228 7.32 9.47228 7.08 9.88228 6.91L10.9423 6.48L11.1023 5.35L11.3023 4H12.6923L13.0423 6.48L14.1023 6.91C14.5323 7.09 14.9323 7.32 15.3323 7.62L16.2423 8.32L17.3023 7.89L18.5723 7.38L19.2723 8.59L18.2023 9.44L17.3123 10.14L17.4523 11.27ZM12.0023 8C9.79228 8 8.00228 9.79 8.00228 12C8.00228 14.21 9.79228 16 12.0023 16C14.2123 16 16.0023 14.21 16.0023 12C16.0023 9.79 14.2123 8 12.0023 8ZM12.0023 14C10.9023 14 10.0023 13.1 10.0023 12C10.0023 10.9 10.9023 10 12.0023 10C13.1023 10 14.0023 10.9 14.0023 12C14.0023 13.1 13.1023 14 12.0023 14Z" fill="white"/>
              </svg>
            </template>
          </ResponsiveButton>
          <!-- <Button color-type="dark-blue" @click = "goToPracticeSettingPage">
            <div style="display: flex; align-items: center; gap: 8px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M19.4323 12.98C19.4723 12.66 19.5023 12.34 19.5023 12C19.5023 11.66 19.4723 11.34 19.4323 11.02L21.5423 9.37C21.7323 9.22 21.7823 8.95 21.6623 8.73L19.6623 5.27C19.5723 5.11 19.4023 5.02 19.2223 5.02C19.1623 5.02 19.1023 5.03 19.0523 5.05L16.5623 6.05C16.0423 5.65 15.4823 5.32 14.8723 5.07L14.4923 2.42C14.4623 2.18 14.2523 2 14.0023 2H10.0023C9.75228 2 9.54228 2.18 9.51228 2.42L9.13228 5.07C8.52228 5.32 7.96228 5.66 7.44228 6.05L4.95228 5.05C4.89228 5.03 4.83228 5.02 4.77228 5.02C4.60228 5.02 4.43228 5.11 4.34228 5.27L2.34228 8.73C2.21228 8.95 2.27228 9.22 2.46228 9.37L4.57228 11.02C4.53228 11.34 4.50228 11.67 4.50228 12C4.50228 12.33 4.53228 12.66 4.57228 12.98L2.46228 14.63C2.27228 14.78 2.22228 15.05 2.34228 15.27L4.34228 18.73C4.43228 18.89 4.60228 18.98 4.78228 18.98C4.84228 18.98 4.90228 18.97 4.95228 18.95L7.44228 17.95C7.96228 18.35 8.52228 18.68 9.13228 18.93L9.51228 21.58C9.54228 21.82 9.75228 22 10.0023 22H14.0023C14.2523 22 14.4623 21.82 14.4923 21.58L14.8723 18.93C15.4823 18.68 16.0423 18.34 16.5623 17.95L19.0523 18.95C19.1123 18.97 19.1723 18.98 19.2323 18.98C19.4023 18.98 19.5723 18.89 19.6623 18.73L21.6623 15.27C21.7823 15.05 21.7323 14.78 21.5423 14.63L19.4323 12.98ZM17.4523 11.27C17.4923 11.58 17.5023 11.79 17.5023 12C17.5023 12.21 17.4823 12.43 17.4523 12.73L17.3123 13.86L18.2023 14.56L19.2823 15.4L18.5823 16.61L17.3123 16.1L16.2723 15.68L15.3723 16.36C14.9423 16.68 14.5323 16.92 14.1223 17.09L13.0623 17.52L12.9023 18.65L12.7023 20H11.3023L10.9523 17.52L9.89228 17.09C9.46228 16.91 9.06228 16.68 8.66228 16.38L7.75228 15.68L6.69228 16.11L5.42228 16.62L4.72228 15.41L5.80228 14.57L6.69228 13.87L6.55228 12.74C6.52228 12.43 6.50228 12.2 6.50228 12C6.50228 11.8 6.52228 11.57 6.55228 11.27L6.69228 10.14L5.80228 9.44L4.72228 8.6L5.42228 7.39L6.69228 7.9L7.73228 8.32L8.63228 7.64C9.06228 7.32 9.47228 7.08 9.88228 6.91L10.9423 6.48L11.1023 5.35L11.3023 4H12.6923L13.0423 6.48L14.1023 6.91C14.5323 7.09 14.9323 7.32 15.3323 7.62L16.2423 8.32L17.3023 7.89L18.5723 7.38L19.2723 8.59L18.2023 9.44L17.3123 10.14L17.4523 11.27ZM12.0023 8C9.79228 8 8.00228 9.79 8.00228 12C8.00228 14.21 9.79228 16 12.0023 16C14.2123 16 16.0023 14.21 16.0023 12C16.0023 9.79 14.2123 8 12.0023 8ZM12.0023 14C10.9023 14 10.0023 13.1 10.0023 12C10.0023 10.9 10.9023 10 12.0023 10C13.1023 10 14.0023 10.9 14.0023 12C14.0023 13.1 13.1023 14 12.0023 14Z" fill="white"/>
              </svg>
              <span> Practice Setting </span>
            </div>
          </Button> -->
        </div>
      </div>
    </div>

    <div class="dashboard-body">
      <CurrentClinicSection />

      <div class="dashboard-content">
        <div class="charts-column">
          <TopKPIs />
          <PatientGrowthChart />
          <PatientEngagementSection />
          <OrdersAndRevenueChart />
          <ProviderDocumentsSection />
          <TransactionsSection />
        </div>

        <transition name="slide-panel">
          <div v-if="aiPanelOpen" class="ai-column">
            <AIAssistantPanel />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import moment from 'moment';
// import Button from '@/NewLibrary/Button.vue';
import CurrentClinicSection from './components/CurrentClinicSection.vue';
import TopKPIs from './components/TopKPIs.vue';
import PatientGrowthChart from './components/PatientGrowthChart.vue';
import PatientEngagementSection from './components/PatientEngagementSection.vue';
import OrdersAndRevenueChart from './components/OrdersAndRevenueChart.vue';
import ProviderDocumentsSection from './components/ProviderDocumentsSection.vue';
import TransactionsSection from './components/TransactionsSection.vue';
import AIAssistantPanel from './components/ai-panel/AIAssistantPanel.vue';

const store = useStore();

const isPageLoading = computed(() => store.state.myPractice.clinicDashboard.isPageLoading);
const aiPanelOpen = computed(() => store.state.myPractice.clinicDashboard.aiPanelOpen);
const cacheUpdateTime = computed(() => store.state.myPractice.clinicDashboard.cacheUpdateTime);

const router = useRouter();

const goToPracticeSettingPage = () => {
  router.push('/my-practice/practice-setting');
};

function getTimeDifferenceFromNow(time) {
  return moment(time).fromNow();
};

// Resources & Tools Dropdown
const showResourcesDropdown = ref(false);
const resourcesToolsRef = ref(null);

function toggleResourcesDropdown() {
  showResourcesDropdown.value = !showResourcesDropdown.value;
}

function handleToolClick(tool) {
  console.log('Tool clicked:', tool);
  var baseUrl = process.env.VUE_APP_ENV==='production' ? 'https://portal.vibrant-wellness.com/' : 'https://staging.va-portal.pages.dev/';
  var url;
  switch (tool) {
    case 'fedex':
      url = `${baseUrl}#/fedexPickup`;
      break;
    case 'calculator':
      url = `${baseUrl}#/testpricecalculator`;
      break;
    case 'blood-draw':
      url = 'https://phleb.vibrant-wellness.com/blood-draw-maps/v2';
      break;
    default:
      url = '';
  }
  if (url) {
    window.open(url, '_blank');
  }
  // TODO: Implement navigation or action for each tool
  showResourcesDropdown.value = false;
}

// Click outside to close dropdown
function handleClickOutside(event) {
  if (resourcesToolsRef.value && !resourcesToolsRef.value.contains(event.target)) {
    showResourcesDropdown.value = false;
  }
}

onMounted(() => {
  store.dispatch('myPractice/clinicDashboard/initializeDashboard');
  document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
  // Don't reset state - filters are preserved in localStorage
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped>
.clinic-dashboard {
  height: calc(100vh - var(--nav-height, 60px));
  background: #F9FBFD;
  display: flex;
  flex-direction: column;
}

.dashboard-page-head {
  padding: 12px 64px;
  background: #F9FBFD;
}

.page-head-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.page-head-left {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 4px 0;
}

.page-title {
  font-family: 'Inter', sans-serif;
  font-size: 28px;
  font-weight: 500;
  line-height: 40px;
  color: #333;
  margin: 0;
}
.update-time{
  color: var(--TrueBlack, #333);

  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: 0.15px;
}

.page-description {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #666;
  margin: 0;
}

.page-head-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.resources-tools-wrapper {
  position: relative;
}

.resources-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  transform: translateX(-30%);
  background: #FFFFFF;
  border-radius: 10px;
  box-shadow: 0px 1px 15px 0px rgba(164, 164, 164, 0.25);
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 1100; 
}

.tools-grid {
  display: flex;
  gap: 8px;
}

.tool-card {
  width: 184px;
  background: #FFFFFF;
  border: 1px solid #C4C4C4;
  border-radius: 10px;
  padding: 16px 12px;
  display: flex;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.tool-card:hover {
  background-color: #F9FBFD;
}
.tool-content-wrapper{
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex:1;
}

.tool-icon {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.tool-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.tool-title {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333333;
  margin: 0;
}

.tool-description {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #666666;
  margin: 0;
}

.tool-arrow {
  width: 30px;
  height: 36px;
  padding: 0 4px;
  flex-shrink: 0;
}


.dashboard-body {
  flex: 1;
  padding: 16px 64px;
  background-color: #fff;
  box-shadow: 0 1px 15px 0 rgba(164, 164, 164, 0.25);
  display: flex;
  flex-direction: column;
  min-height: 0;
  position: relative;
}

.dashboard-content {
  display: flex;
  gap: 16px;
  margin-top: 16px;
  flex: 1;
  min-height: 0;
}

.charts-column {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.ai-column {
  width: 324px;
  flex-shrink: 0;
  position: sticky;
  right: 0;
  top: 0;
}

.slide-panel-enter-active,
.slide-panel-leave-active {
  transition: all 0.3s ease;
}

.slide-panel-enter-from,
.slide-panel-leave-to {
  opacity: 0;
  transform: translateX(20px);
}
</style>
